import { render, staticRenderFns } from "./magProgram.vue?vue&type=template&id=6e2800c4&"
import script from "./magProgram.vue?vue&type=script&lang=ts&"
export * from "./magProgram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports